<template>
  <div class="images">
    <h2>Obrazki</h2>
    <div class="load">
      <p>Dodaj obrazek z adresu URL</p>
      <el-input class="input" placeholder="Adres url obrazka" v-model="image"></el-input>
      <el-button class="add" v-if="image" type="primary" @click="handleLoad">Dodaj</el-button>
    </div>
    <el-divider content-position="center">lub wybierz</el-divider>
    <div class="list">
      <el-card shadow="hover" class="box-card image" v-for="(image, index) in allImages" :key="index">
        <img @click="add(image)" :src="image" width="100" />
      </el-card>
    </div>
  </div>
</template>

<script>
  import Editor from '../../classes/Editor';
  import { mapGetters, mapActions } from 'vuex'

  export default {
    data() {
      return {
        image: ''
      }
    },
    computed: {
      ...mapGetters('file', [
        'img',
        'icons',
      ]),
      allImages() {
        return [...this.img, ...this.icons];
      }
    },
    mounted() {
      this.getImages();
    },
    methods: {
      ...mapActions('file', [
        'getImages',
      ]),
      handleLoad() {
        this.add(this.image)
      },
      add(img) {

        if (Editor.canvas.getActiveObject() && Editor.canvas.getActiveObject().type === 'image') {
          Editor.canvas.getActiveObject().setSrc(img, () => {
            Editor.canvas.renderAll();
          })

          return
        }

        Editor.addImage(img)
      }
    }
  }
</script>

<style lang="less" scoped>
  .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .add {
    width: 100%;
    margin-top: 15px;
  }

  .load {
    background: #f7f7f7;
    padding: 10px;
    box-sizing: border-box;
  }

  .images {
    .el-collapse-item__content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      .el-card__body {
        height: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .el-button {
          display: none;
        }
      }
    }
    .box-card {
      width: 31%;
      height: 100px;
      &.image {
        font-size: 12px;
        margin-bottom: 10px;
        img {
          max-height: 100%;
          max-width: 100%;
          width: auto;
        }
      }
    }
  }
</style>
